module.exports = __webpack_public_path__ + "static/media/tutor-th-6.20198652.jpg";